import React from 'react';
import { ArrowRightIcon, ChevronArrowRightIcon, CrossIconvector, SearchWithBgIcon } from 'assets/icons';
import { NoPermissions } from 'components';
import { ManualPaymentMethods } from 'containers/home/components/constants';
import { InvoiceByIdV2 } from '../invoices.model';

interface RecordPaymentMethodSelectionProps {
  isRootState: boolean;
  handleSidePanelBack: () => void;
  invoiceData: InvoiceByIdV2;
  hasManualPaymentMethod: boolean;
  onMethodSelect: (methodId: string) => void;
}

const RecordPaymentMethodSelection: React.FC<RecordPaymentMethodSelectionProps> = ({
  isRootState,
  handleSidePanelBack,
  invoiceData,
  hasManualPaymentMethod,
  onMethodSelect
}) => {
  return (
    <>
      <div className="flex flex-row items-center px-4 pt-5 pb-3">
        <div
          id={`${isRootState ? 'record-payment-panel-close-button' : 'record-payment-panel-back-button'}`}
          onClick={handleSidePanelBack}
          className="cursor-pointer">
          {isRootState ? (
            <CrossIconvector className="shrink-0" />
          ) : (
            <ArrowRightIcon
              className="path-fill-current path h-5 w-5
              shrink-0 rotate-180 cursor-pointer text-heading"
            />
          )}
        </div>
      </div>

      {invoiceData?.isModifiable && hasManualPaymentMethod ? (
        <div className={'px-4'}>
          <div className="flex flex-col items-start">
            <div id="record-payment-panel-header" className={'text-17px font-bold text-primaryText'}>
              How did the customer pay?
            </div>
            <div className={'mt-2 text-px13 font-medium text-primaryText'}>Choose a payment method</div>
          </div>
          <div className="divide-y divide-[#F2F2F2]">
            {ManualPaymentMethods.map(method => {
              return (
                <div
                  key={method.key}
                  onClick={() => onMethodSelect(method.key)}
                  className="flex cursor-pointer items-center justify-between
                   border-gray-200 py-4 px-1 transition-colors hover:bg-gray-50">
                  <div className="flex items-center gap-3.5">
                    <method.icon className="h-5 w-5 shrink-0" />
                    <span className="text-sbase font-semibold text-primaryText">{method.value}</span>
                  </div>
                  <ChevronArrowRightIcon className="path-fill-current h-4 w-4 shrink-0 text-gray-1" />
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <>
          {!invoiceData.isModifiable && <NoPermissions />}
          {!hasManualPaymentMethod && (
            <div className="mt-10 flex flex-col items-center gap-2 text-sbase font-semibold text-primaryText">
              <div>
                <SearchWithBgIcon />
              </div>
              <div>No manual payment methods found</div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default RecordPaymentMethodSelection;
